import { Anchor } from "@omni/ui/components/Anchor/anchor.component";
import { Divider } from "@omni/ui/components/Divider/divider.component";
import { cn } from "@omni/utils/styles";

import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    id: string;
    creationDate: string;
    totalPrice: string;
};

const OrderSummary = ({ id, creationDate, totalPrice }: Props) => {
    const { t } = useGranite();

    return (
        <>
            <Row className="py-2 m-0 bg-light-gray justify-content-between flex-wrap">
                <div className="col font-weight-bold align-self-start">
                    {creationDate}
                    <span className="px-2 text-gray">|</span>
                    {id}
                    <span className="px-2 text-gray d-none d-sm-inline-block">
                        |
                    </span>
                    <span className="d-none d-sm-inline-block">
                        {totalPrice}
                    </span>
                </div>
                <div className="col-auto justify-content-end align-self-end text-nowrap">
                    <Anchor
                        color="link"
                        className={cn("tw:float-right tw:p-0")}
                        href={`./${id}/`}
                    >
                        {t("account.orders.orderDetails.link")}
                        <i className="las la-angle-right pl-1" />
                    </Anchor>
                </div>
            </Row>
            <Divider marginTop="0" />
        </>
    );
};

export default OrderSummary;
